/** @jsx jsx */
import { jsx } from '@emotion/core'
import { modal } from 'bold-ui'
import { ModalAutoRenderProps } from 'bold-ui/lib/components/Modal/auto/ModalAuto'
import { composeHandlers } from 'bold-ui/lib/util/react'

import { AlterarSenhaForm, AlterarSenhaFormProps } from './AlterarSenhaForm'

interface AlterarSenhaModalFormProps
  extends Omit<AlterarSenhaFormProps, 'onCancelar' | 'afterSubmit' | 'supressAlertError'> {
  title?: string
}

export const alterarSenhaModalForm = (props: AlterarSenhaModalFormProps) => {
  const { title = 'Redefinir senha', ...alterarSenhaProps } = props

  return () =>
    new Promise<boolean>((resolve) => {
      let promiseReturn = false
      const handleResolve = (confirm: boolean) => () => (promiseReturn = confirm)
      const handleClose = () => resolve(promiseReturn)

      modal({
        title: title,
        size: 'large',
        icon: {
          name: 'infoCircleOutline',
          fill: 'primary',
        },
        closeOnBackdropClick: false,
        render: ({ close }: ModalAutoRenderProps) => (
          <AlterarSenhaForm
            {...alterarSenhaProps}
            onSubmitSucceeded={composeHandlers(handleResolve(true), close)}
            onCancelar={composeHandlers(handleResolve(false), close)}
            supressAlertError
            isSenhaProvisoria
          />
        ),
        onClose: handleClose,
      })()
    })
}
